module.exports = __webpack_public_path__ + "img/swipe-right.d604218b.svg";